import React from 'react';
import { Link } from 'react-router-dom';
import Lottie from "lottie-react";

import rtmi01 from '../../assets/imgs/rtmicapital/lion_loan.png'; 
import rtmi02 from '../../assets/imgs/rtmicapital/lion_stand.png'; 
import rtmi03 from '../../assets/imgs/rtmicapital/lion_credit.png'; 
import rtmi04 from '../../assets/imgs/rtmicapital/lion_cu.png'; 
import rtmi05 from '../../assets/imgs/rtmicapital/lion_sheet.png'; 


import rtmiAniamtion01 from '../../assets/imgs/rtmicapital/application-process.json'; 
import rtmiAniamtion02 from '../../assets/imgs/rtmicapital/factoring 2.json'; 
import rtmiAniamtion03 from '../../assets/imgs/rtmicapital/business-loans.json'; 
import rtmiAniamtion04 from '../../assets/imgs/rtmicapital/line-of-credit.json'; 


import navina from '../../assets/imgs/navina/navina_web_animations_cover.jpg'; 


const RtmiCapitalPage = () => {

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []); 






  return (
              
        <div className='bg-light'>
          <div className='header-height bg-white' ></div>

                <div className='row bg-white'>
                <div className='col-sm-2 col-xs-12'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row px-3 px-sm-5 mb-4'>
                  <div className='col-md text-start'>
                    <p className='fs-2 fw-normal capitalize mb-2'>RTMI Capital</p>
                    <p className='fs-1rem fw-light capitalize'>
                    Bringing a New Brand to Life
                    </p>
                    <p className='mt-4 fw-light'>2025</p>
                  </div>
                  <div className='col-md'>
                    <p className='fw-normal fs-5'>
                      RTMI Capital provides financial growth solutions for businesses across the United States. We collaborated to develop a brand-new identity from the ground up, including a unique character design that enhances brand recognition and memorability across all branding materials.
                    </p>
                  </div>
              </div>
            </div>

        </div>

        <video className='py-0 my-0' width="100%" height="auto" autoPlay loop muted>
                  <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/rtmi_capital_homepage1.mp4" type="video/mp4" />
                </video>


      <div className='row align-items-center px-3 px-sm-5 py-5 my-5'>
        <div className='col-md-6 col-sm-10 col-xs-12 mb-5 pb-5'>
          <p className='fs-5'>
            Designed with precision and purpose, this website serves as a digital gateway for businesses seeking financial solutions. Created for a leading capital company, the platform is tailored to attract entrepreneurs and business owners looking for seamless funding opportunities. Through a simple and intuitive application process, users can effortlessly submit their requests and access the financial support they need.
          </p>
          <br></br>
          <p className='fs-5'>
            The design philosophy behind this website is rooted in clarity and confidence. A minimalist, clean layout ensures that visitors can navigate the site without distractions, keeping their focus on what matters—securing funds for their business growth. The dominant use of yellow reflects optimism, energy, and financial success, creating an inviting atmosphere that inspires trust and action.
          </p>
        </div>

          <div className='col-sm-12 col-md-10 px-0 px-md-5'>
          <div className='row '>
            <video width="100%" height="auto" autoPlay muted loop>
              <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/mockup-website_rtmicapital.mp4" type="video/mp4" />
            </video>
          </div>
      </div>
        <div className='col-sm col-xs-12 p-0 p-sm-5'>

        </div>
      </div>





    <div className='row px-3 px-sm-5 mt-1 mt-sm-5 pt-5'>
      <div className='col-sm-2 col-xs-12'></div>
      <div className='col-md col-xs-12'>
        <div className='row m-0 p-0'>
        <div className='col-md col-sm col-xs-12'>
        </div>
          <div className='col-sm-10 col-md col-xs-12'>
            <h5>
            Character Design
            </h5>
          <p className='fs-5'>
          To make the brand not only strong and trustworthy but also approachable and memorable, a unique cartoon lion character was created. While finance and power often carry a serious and corporate tone, the character brings warmth, relatability, and a sense of ease to the brand identity.
            </p>
            <br></br>
            <p className='fs-5'>
            More than just a visual element, the lion serves as a brand ambassador, making financial solutions feel more approachable and less daunting. By blending professionalism with playfulness, the character adds a unique touch that sets the brand apart, ensuring a lasting impression on its audience.
            </p>
        </div>
      </div>
      </div>
    

      <div className='row m-0 p-2 p-sm-0 my-5'>
        <div className='col-sm-2 col-xs-12 p-0'></div>
        <div className='col-sm col-xs-12 p-0'>
          <div className='row p-0'>
        <div className='col-md-6 col-xs-12 my-3'>
        <img className='img-fluid' src={rtmi02} alt="RTMI lion" />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        <img className='img-fluid' src={rtmi03} alt="RTMI lion" />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
          <img className='img-fluid' src={rtmi04} alt="RTMI lion" />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
          <img className='img-fluid' src={rtmi01} alt="RTMI lion" />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        </div>
      </div>
    </div>
    </div>
    </div>



    <div className='row'>
      <img className='img-fluid' src={rtmi05} alt="Navina Risk 1" />
    </div>



    <div className='row my-5 px-3 px-sm-5'>
      <div className='col-sm col-xs-12 my-5'>
        <div className='row'>
        <div className='col-sm-6 col-xs-12 d-flex align-items-end'>
          <div>
          <h5>Animations made for the website</h5>
        <p className='fs-5 mt-4'>
        To create an engaging and dynamic user experience, a series of animated loops was designed and embedded into the website using the Lottie framework. These animations serve as visual storytelling elements, simplifying complex financial solutions and making the content more digestible for visitors."            </p>
        </div>
        </div>
          <div className='col-sm-6 col-xs-12 d-flex align-items-end'>
          <p className='fs-5 mt-4'>
        To create an engaging and dynamic user experience, a series of animated loops was designed and embedded into the website using the Lottie framework. These animations serve as visual storytelling elements, simplifying complex financial solutions and making the content more digestible for visitors."            </p>

        </div>
      </div>
      </div>
    

      <div className='row px-3 px-sm-5 my-5'>
      <div className='col-sm-2 col-xs-12'></div>
        <div className='col-sm col-xs-12 p-0'>
          <div className='row p-0'>
        <div className='col-md-6 col-xs-12 my-3'>
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        <Lottie animationData={rtmiAniamtion02} loop={true} />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        <Lottie animationData={rtmiAniamtion03} loop={true} />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        <Lottie animationData={rtmiAniamtion04} loop={true} />
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        </div>
        <div className='col-md-6 col-xs-12 my-3'>
        <Lottie animationData={rtmiAniamtion01} loop={true} />
        </div>
      </div>
    </div>
    </div>
    </div>



<div className='row py-5 px-3 px-sm-5'>
<div className='col-sm-2 col-xs-12'></div>
<div className='col-sm col-xs-12'>

  <div className='py-2'>
    <Link to={"https://rtmicapital.com"}>
            <a className='d-inline-flex align-items-center fs-5 fw-bold text-dark'>
            <h5 className='fs-18 fw-600'>Client: RTMI Capital</h5>
            <div className='arrow-out'></div>
              </a>
                </Link>
                    </div>

    <div className='py-2'></div>


    <div className='row'>
      <div className='col-md col-sm-6 col-xs-12'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
            <li className='py-1'>UX/UI</li>
            <li className='py-1'>Web design</li>
            <li className='py-1'>Frontend-development</li>
            <li className='py-1'>animation</li>
            <li className='py-1'>3D modeling</li>
            <li className='py-1'>Rigging</li>

          </ul>
      </div>
      <div className='col-md col-sm-6 col-xs-12'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Maya</li>
            <li className='py-1'>Substance painter</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Illustrator</li>
            <li className='py-1'>Photosop</li>
            <li className='py-1'>Lottie</li>
            <li className='py-1'>Webflow</li>
          </ul>
      </div>
      
      <div className='col-md col-sm-6 col-xs-12'>
        <h5 className='fs-18 fw-600'>Cooperation</h5>
          <ul className='p-0'>
            <li className='py-1'>Ongoing</li>

          </ul>
      </div>

      <div className='col-md col-sm-6 col-xs-12'>
        <h5 className='fw-600'>Industry</h5>
            <li className='py-1'>Capital</li>
            <h5 className='fw-600 pt-2'>Duration</h5>
            <li className='py-1'>3 Months</li>
      </div>
    </div>
</div>
</div>

<div className='row mx-0 mt-3 mt-sm-5'>
  <div className='col-sm-12 col-xs-12 text-end p-5'>
      <Link to={"/navina"}>
        <a className='fs-5 fw-bold text-dark'>
          Next work 
          <div className='arrow-right'></div>
          </a>
            </Link>
        </div>
        <div className='col-md-2 col-sm-12 col-xs-12 p-3 p-md-5'>

        </div>
          <div className='col-md col-sm-12 col-xs-12 p-3 p-md-5'>
          <Link to={"/navina"}>
            <div className='image-box-300'>
              <img src={navina} alt="prodbo next" />
            </div>
          </Link>
        </div>
      </div>


</div>


  );
};

export default RtmiCapitalPage;
